// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__cmQby","inputWrap":"CustomTip_inputWrap__1Ij6n"};